<div class="contauner" #routerOutletRef>
    <div class="row-xl-12">
        <app-header [headerSettings]="headerSettings"></app-header>
    </div>
</div>
<div *ngIf="isPRW === true">
    <app-menu-dab></app-menu-dab>
</div>
<router-outlet></router-outlet>
<div *ngIf="showFooterAfterDelay">
    <app-footer [footerSettings]="footerSettings"></app-footer>
</div>